import React from "react";
import { workExperience } from "../data/index";
import { Button } from "../ui/MovingBorders";
import "./experience.css"; // import your CSS file

const Experience = () => {
  return (
    <div className="experience-container">
      <h1 className="experience-heading">
        Our <span className="highlight">work experience</span>
      </h1>

      <div className="experience-grid">
        {workExperience.map((card) => (
          <Button
            key={card.id}
            duration={Math.floor(Math.random() * 10000) + 10000}
            borderRadius="1.75rem"
            style={{
              background: "rgb(4,7,29)",
              backgroundColor:
                "linear-gradient(90deg, rgba(4,7,29,1) 0%, rgba(12,14,35,1) 100%)",
              borderRadius: `calc(1.75rem * 0.96)`,
            }}
            className="experience-card"
          >
            <div className="experience-content">
              <img
                src={card.thumbnail}
                alt={card.thumbnail}
                className="experience-thumbnail"
              />
              <div className="experience-details">
                <h1 className="experience-title">{card.title}</h1>
                <p className="experience-description">{card.desc}</p>
              </div>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default Experience;
